var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconRefresh(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 10,
    viewBox: "0 0 12 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.77786 4.9999C7.77786 4.44116 7.32072 3.98402 6.76199 3.98402C6.20326 3.98402 5.74611 4.44116 5.74611 4.9999C5.74611 5.55863 6.20326 6.01577 6.76199 6.01577C7.32072 6.01577 7.77786 5.55863 7.77786 4.9999ZM6.76199 0.428467C4.23754 0.428467 2.19056 2.47545 2.19056 4.9999H0.666748L2.69849 7.03164L4.73024 4.9999H3.20643C3.20643 3.03418 4.79627 1.44434 6.76199 1.44434C8.7277 1.44434 10.3175 3.03418 10.3175 4.9999C10.3175 6.96561 8.7277 8.55545 6.76199 8.55545C5.995 8.55545 5.28389 8.30656 4.69976 7.89513L3.97849 8.62656C4.75056 9.21577 5.71564 9.57132 6.76199 9.57132C9.28643 9.57132 11.3334 7.52434 11.3334 4.9999C11.3334 2.47545 9.28643 0.428467 6.76199 0.428467Z",
    fill: "#4C4E54"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconRefresh);
export default __webpack_public_path__ + "static/media/icon-refresh.fe4b23e0.svg";
export { ForwardRef as ReactComponent };